export enum facebookCTAButtons {
    CONTACT_US = 'CONTACT_US',
    OPEN_APP = 'OPEN_APP',
    VIEW_SHOP = 'VIEW_SHOP',
    SIGN_UP = 'SIGN_UP'
}

// all Facebook CTA
// BOOK_NOW, REQUEST_QUOTE, CALL_NOW, CHARITY_DONATE, CONTACT_US, DONATE_NOW, MESSAGE, OPEN_APP, PLAY_NOW, SHOP_NOW, SIGN_UP, WATCH_NOW, GET_OFFER, GET_OFFER_VIEW, BOOK_APPOINTMENT, LISTEN, EMAIL, LEARN_MORE, REQUEST_APPOINTMENT, GET_DIRECTIONS, BUY_TICKETS, PLAY_MUSIC, VISIT_GROUP, SHOP_ON_FACEBOOK, LOCAL_DEV_PLATFORM, INTERESTED, WOODHENGE_SUPPORT, BECOME_A_VOLUNTEER, VIEW_SHOP, PURCHASE_GIFT_CARDS, FOLLOW_PAGE, ORDER_FOOD, VIEW_INVENTORY, MOBILE_CENTER, VIEW_MENU